import __request__ from "routing/request";
export function getCertificates(requestOptions) {
  return __request__("GET", "/certificates", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
